export default [
  {
    title: 'Dashboard',
    icon: { icon: 'tabler-smart-home' },
    to: {
      name: 'dashboards',
    },
  },
  {
    title: 'Profile',
    to: {
      name: 'app-profile',
      meta: { hidden: true },
    },
  },
]
